let DateBlock;

import moment from 'moment';
import React from 'react';

export default (DateBlock = class extends React.Component {
  render() {
    const d = moment(this.props.date);
    let style = {
      color: 'white',
      fontSize: '12px',
      alignItems: 'center'
    };

    return (
      <div className="flex-row" style={style}>
        <div className="date-padding flex-none">
          <div className="day-name">{d.format('dddd')}</div>
          <div className="month-name">{d.format('MMMM')}</div>
        </div>
        <div className="flex-none">
          <div className="day-number">{d.format('DD')}</div>
        </div>
      </div>
    );
  }
});
